module.exports = __webpack_public_path__ + "static/img/23a.0cc8c80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/23a.jpg
// module id = HLAw
// module chunks = 0